module.exports = __webpack_public_path__ + "static/media/27.adf0370d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/27.jpg
// module id = 717
// module chunks = 0